module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum07-cdccb637e1d4d5946e00b57120985dad.png";